import { useEffect, useState } from "react";
import api from "@/api/client";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

function useCountdown(iso) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(i); }, []);
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, over: diff <= 0 };
}

export default function DropCountdown() {
  const [drops, setDrops] = useState([]);
  useEffect(() => { api.get("/drops/active").then((r) => setDrops(r.data || [])).catch(() => setDrops([])); }, []);
  const drop = drops[0];
  const isLive = drop?.state === "live";
  const cd = useCountdown(isLive ? drop?.end_at : drop?.start_at);
  if (!drop) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 lg:px-8 mt-6" data-testid="drop-countdown">
      <Link to={`/drops/${drop.id}`} className="block group">
        <div className="overflow-hidden rounded-3xl border border-[#F48E2E]/30 bg-[#111827] text-white">
          {drop.banner_image && (
            <div className="relative overflow-hidden bg-gray-100 aspect-[8/3]">
              <img src={drop.banner_image} alt="" className="w-full h-full object-contain sm:object-cover object-center" />
            </div>
          )}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-6 md:p-8">
            <div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2 flex items-center gap-1">
                <Sparkles className="h-3 w-3" /> {isLive ? "Drop live now" : "Drop starting soon"}
              </div>
              <h2 className="font-display text-3xl md:text-4xl mb-1">{drop.name}</h2>
              {drop.theme && <div className="text-sm text-white/80">Theme · {drop.theme}</div>}
              {drop.tagline && <div className="text-sm text-white/70 mt-1 max-w-xl">{drop.tagline}</div>}
            </div>
            <div className="flex items-center gap-2 md:gap-3" data-testid="drop-timer">
              {cd && ["d","h","m","s"].map((k) => (
                <div key={k} className="min-w-[64px] rounded-xl bg-white/10 backdrop-blur px-3 py-2 text-center">
                  <div className="font-display text-2xl md:text-3xl font-bold">{String(cd[k]).padStart(2, "0")}</div>
                  <div className="text-[10px] uppercase tracking-widest text-white/70">{k === "d" ? "days" : k === "h" ? "hrs" : k === "m" ? "min" : "sec"}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </section>
  );
}
